const projects = [{
        sectionId: "projects",
        language: "en",
        title: "Projects",
        content: {
            intro: "On the cards below, you will find information about some of the projects I have worked on in the year of 2020. The green button on the bottom-right corner of each card displays more information, including the technologies utilized.",
            body: [{
                    title: "The Kira Justice",
                    live: "https://www.thekirajustice.com.br/",
                    image: "tkj",
                    front: "Website for local pop-rock band.",
                    back: "The project was built with two main concerns in mind: it had to focus on the band's newest release, and, whenever they are broadcasting live, users had to be able to watch it through the website and participate on the live chat.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "php",
                            "mysql"
                        ]
                    }
                },
                {
                    title: "Cryptaid",
                    live: "https://cryptaid.vercel.app",
                    image: "cryp",
                    front: "Digital aid for the Cryptid board game.",
                    back: "This is a progressive web app made with Vue. It's a digital aid for the Cryptid board game made for mobile. Implements SwiperJS and i18n external libraries.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "vue",
                            "swiperjs",
                            "i18n",
                            "html5",
                            "css3",
                            "javascript"
                        ]
                    }
                },
                {
                    title: "Empório da Lasanha",
                    image: "edl",
                    front: "Website for food delivery business.",
                    back: "The client requested an online menu with a short description for every item, as well as a phone and WhatsApp order system. Aside from one external service that requires javascript and the admin dashboard, the landing page was built solely with HTML and CSS.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "php",
                            "mysql"
                        ]
                    }
                },
                {
                    title: "Item Generator",
                    live: "https://item-generator.herokuapp.com/",
                    image: "ig",
                    front: "A PWA for tabletop RPG players.",
                    back: "A simple personal project made to do some experimentation with React-Query and service workers. Every entry is randomly fetched from a MongoDB collection.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "react",
                            "nodejs",
                            "mongodb"
                        ]
                    }
                },
                {
                    title: "My Portfolio",
                    image: "mda",
                    front: "My very own online portfolio.",
                    back: "An SPA I made for some dude who needed a place online to keep his portfolio and contact information accessible. Yes, this is the webpage you are currently viewing. Every animation was done purely with CSS.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "react"
                        ]
                    }
                },
                {
                    title: "Letmeask",
                    image: "lma",
                    live: "https://letmeask-7e901.web.app/",
                    front: "A real-time Q&A web app.",
                    back: "A React web application developed during Rocketseat's June 2021 Next Level Week. It was created as a tool to help streamers and live-broadcasters engage with their audience.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "typescript",
                            "firebase",
                            "react"
                        ]
                    }
                },

                {
                    title: "Todobedoo!",
                    image: "tdbd",
                    live: "https://mdaffonso.github.io/frontend2/todobedoo/",
                    front: "A simple to-do app with only vanilla Javascript.",
                    back: "A to-do app developed using exclusively vanilla Javascript, HTML and CSS. It was made as an exercise for building a simple SPA without using front end frameworks and consuming an external API.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "javascript"
                        ]
                    }
                },

                {
                    title: "Memory Cards",
                    image: "mc",
                    live: "https://mdaffonso.github.io/frontend2/memorycards/",
                    front: "An accessibility-focused flash cards app.",
                    back: "A flash cards app developed using vanilla Javascript, HTML and CSS (with SASS). It focuses on accessibility, and can be utilized solely with a keyboard.",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "sass",
                            "javascript"
                        ]
                    }
                },

                {
                    title: "Jokenpo",
                    image: "jkp",
                    live: "https://mdaffonso.github.io/frontend2/jokenpo/",
                    front: "It's rock, paper, scissors. Simple and straightforward.",
                    back: "A fully responsive rock, paper, scissors game, made with vanilla Javascript, HTML and CSS (with SASS).",
                    technologies: {
                        title: "Technologies employed:",
                        list: [
                            "html5",
                            "css3",
                            "sass",
                            "javascript"
                        ]
                    }
                }
            ],
        },
    },


    {
        sectionId: "projects",
        language: "pt",
        title: "Projetos",
        content: {
            intro: "Nos cards abaixo, você encontrará informações sobre alguns dos projetos nos quais eu trabalhei em 2020. O botão verde no canto inferior direito de cada card fornece maiores informações sobre o projeto, incluindo as tecnologias utilizadas.",
            body: [{
                    title: "The Kira Justice",
                    live: "https://www.thekirajustice.com.br/",
                    image: "tkj",
                    front: "Website para uma banda de pop-rock local.",
                    back: "O projeto foi desenvolvido objetivando solucionar dois problemas: foco no lançamento mais recente da banda, e, durante as apresentações ao vivo, inserção do stream de vídeo feito pelo YouTube com sistema de chat ao vivo interno.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "php",
                            "mysql"
                        ]
                    }
                },

                {
                    title: "Cryptaid",
                    live: "https://cryptaid.vercel.app",
                    image: "cryp",
                    front: "Auxílio digital para o jogo de tabuleiro Cryptid.",
                    back: "Um aplicativo de web progressivo feito com Vue. Um auxílio digital para o jogo de tabuleiro Cryptid feito principalmente para mobile. Implementa funcionalidades das bibliotecas SwiperJS e i18n.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "vue",
                            "swiperjs",
                            "i18n",
                            "html5",
                            "css3",
                            "javascript"
                        ]
                    }
                },

                {
                    title: "Empório da Lasanha",
                    image: "edl",
                    front: "Site para empresa de delivery de lasanhas congeladas.",
                    back: "O cliente precisava de um menu virtual, com uma curta descrição de cada item, além de um sistema de pedidos via WhatsApp. Com a exceção de um serviço externo que utiliza javascript, e do painel de controle, a landing page foi construída exclusivamente com HTML e CSS.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "php",
                            "mysql"
                        ]
                    }
                },
                {
                    title: "Item Generator",
                    live: "https://item-generator.herokuapp.com/",
                    image: "ig",
                    front: "Uma PWA para jogadores de RPG de mesa.",
                    back: "Um projeto pessoal simples, que desenvolvi para experimentar com React-Query e service workers. Cada item é buscado aleatoriamente de uma coleção em MongoDB.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "react",
                            "nodejs",
                            "mongodb"
                        ]
                    }
                },
                {
                    title: "Meu Portfolio",
                    image: "mda",
                    front: "Meu portfolio digital.",
                    back: "Uma SPA que desenvolvi para um cara aí que precisava de um ambiente online para manter o seu portfolio e informações de contato acessíveis. Sim, esta é a página que você está visualizando atualmente. Todas as animações foram feitas unicamente com CSS.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "react"
                        ]
                    }
                },
                {
                    title: "Letmeask",
                    image: "lma",
                    live: "https://letmeask-7e901.web.app/",
                    front: "Aplicação de web de perguntas e respostas.",
                    back: "Uma aplicação de web em React desenvolvida durante a Next Level Week da Rocketseat de junho de 2021. Foi criada como uma ferramenta para auxiliar streamers e produtores de conteúdo ao vivo a engajar com a sua audiência.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "javascript",
                            "typescript",
                            "firebase",
                            "react"
                        ]
                    }
                },

                {
                    title: "Todobedoo!",
                    image: "tdbd",
                    live: "https://mdaffonso.github.io/frontend2/todobedoo/",
                    front: "Um aplicativo simples de tarefas feito com Javascript puro.",
                    back: "Um aplicativo de tarefas desenvolvido com Javascript puro, HTML e CSS. Foi feito como um exercício para criar uma SPA simples sem frameworks e consumindo uma API externa.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "javascript"
                        ]
                    }
                },

                {
                    title: "Memory Cards",
                    image: "mc",
                    live: "https://mdaffonso.github.io/frontend2/memorycards/",
                    front: "Um app de flash cards focado em acessibilidade.",
                    back: "Um app de flash cards desenvolvido utilizando Javascript, HTML e CSS (com SASS). Tem foco em acessibilidade, e pode ser inteiramente utilizado com um teclado.",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "sass",
                            "javascript"
                        ]
                    }
                },

                {
                    title: "Jokenpo",
                    image: "jkp",
                    live: "https://mdaffonso.github.io/frontend2/jokenpo/",
                    front: "É pedra, papel e tesoura. Simples e direto.",
                    back: "Pedra, papel e tesoura, feito completamente em Javascript, HTML e CSS (com SASS).",
                    technologies: {
                        title: "Tecnologias utilizadas:",
                        list: [
                            "html5",
                            "css3",
                            "sass",
                            "javascript"
                        ]
                    }
                }
            ],
        },
    }
]

export default projects